import React from 'react'
import { Helmet } from 'react-helmet'
import CssBaseline from '@material-ui/core/CssBaseline'
import { ThemeProvider } from '@material-ui/core/styles'
import theme from '../../src/theme'
import ContactUsCollapseContexProvider from '../../src/utils/context/ContactUsCollapseContext'

export default function TopLayout({ children }) {
  return (
    <>
      <Helmet>
        <meta
          name="viewport"
          content="minimum-scale=1, initial-scale=1, width=device-width"
        />
      </Helmet>
      <ThemeProvider theme={theme}>
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline />
        <ContactUsCollapseContexProvider>
          {children}
        </ContactUsCollapseContexProvider>
      </ThemeProvider>
    </>
  )
}
